/* import __COLOCATED_TEMPLATE__ from './freshdesk.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { IntegrationState } from 'embercom/objects/standalone/constants';

interface Args {
  hideIcon?: boolean;
  showRed?: boolean;
  isSaving?: boolean;
}

export default class FreshdeskPillComponent extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;

  get freshdeskConfig() {
    return this.finStandaloneService.freshdeskConfig;
  }

  get isConnected() {
    return this.freshdeskConfig?.ticketState !== IntegrationState.NotConfigured;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Freshdesk::Pills::Freshdesk': typeof FreshdeskPillComponent;
  }
}
